import { PragmaticChapterDetail } from '@app/interface/pragmatic-chapter-detail';
import { PragmaticProfile } from '@app/interface/pragmatic.profile';
import { ChapterDetailsData } from '@app/interface/user-info';
import { PRAGMATIC_PROFILE_INIT } from '@app/utils/mocks/pragmatic-info.mock';
import { createReducer, on } from '@ngrx/store';
import { PragmaticInfoActions } from './pragmatic-info.action.types';

export const initialPragmaticLogedUser: PragmaticProfile = PRAGMATIC_PROFILE_INIT;
export const initialPragmaticProfile: PragmaticProfile = PRAGMATIC_PROFILE_INIT;
export const initialPragmaticChapterDetails: PragmaticChapterDetail[] = [];
export const initialCurrentChapterDetails: ChapterDetailsData = {} as ChapterDetailsData;

export interface HomePragmaticInfoState {
  pragmaticLogedUser: PragmaticProfile;
  pragmaticProfile: PragmaticProfile;
  pragmaticChapterDetails: PragmaticChapterDetail[];
  currentChapterDetails: ChapterDetailsData;
}

export const initialHomePragmaticInfo: HomePragmaticInfoState = {
  pragmaticLogedUser: initialPragmaticLogedUser,
  pragmaticProfile: initialPragmaticProfile,
  pragmaticChapterDetails: initialPragmaticChapterDetails,
  currentChapterDetails: initialCurrentChapterDetails,
};

export const HomePragmaticInfoReducer = createReducer(
  initialHomePragmaticInfo,

  on(
    PragmaticInfoActions.loadPragmaticLogedUserSuccessfully,
    (state, { pragmaticLogedUser }): HomePragmaticInfoState => {
      return {
        ...state,
        pragmaticLogedUser: pragmaticLogedUser,
      };
    }
  ),

  on(PragmaticInfoActions.loadPragmaticLogedUserFailure, (state): HomePragmaticInfoState => {
    return {
      ...state,
      pragmaticLogedUser: initialPragmaticLogedUser,
    };
  }),

  on(
    PragmaticInfoActions.loadPragmaticProfileSuccess,
    (state, { pragmaticProfile }): HomePragmaticInfoState => {
      return {
        ...state,
        pragmaticProfile: pragmaticProfile,
      };
    }
  ),

  on(PragmaticInfoActions.loadPragmaticProfileFailure, (state): HomePragmaticInfoState => {
    return {
      ...state,
      pragmaticProfile: initialPragmaticProfile,
    };
  }),

  on(
    PragmaticInfoActions.loadPragmaticChapterDetailsSuccess,
    (state, action): HomePragmaticInfoState => {
      return {
        ...state,
        pragmaticChapterDetails: action.pragmaticChapterDetails,
      };
    }
  ),
  on(PragmaticInfoActions.loadCurrentChapterDetails, (state, action): HomePragmaticInfoState => {
    return {
      ...state,
      currentChapterDetails: action.currentChapterDetails,
    };
  }),

  on(PragmaticInfoActions.resetPragmaticProfileState, (state): HomePragmaticInfoState => {
    return {
      ...state,
      pragmaticLogedUser: initialPragmaticLogedUser,
      pragmaticProfile: initialPragmaticProfile,
      pragmaticChapterDetails: initialPragmaticChapterDetails,
      currentChapterDetails: initialCurrentChapterDetails,
    };
  })
);
